export const POLLING_INTERVAL_MESSAGES = 15000;
export const THREAD_LIMIT = 1000;
export const MESSAGE_LIMIT = 20;
export const POLLING_INTERVAL_THREADS = 30000;
